<template>
    <div class="row" v-loading="isLoading">
        <div v-if="field_errors.hasOwnProperty('deal_id')" class="help-block invalid-feedback d-block" v-html="field_errors['deal_id'][0]"/>
        <div class="form-group col-6">
            <label class="mb-0" :for="'initial_payment' + _uid">ПВ по договору</label>
            <input type="number" class="form-control" name="reward" :id="'initial_payment' + _uid" v-model="initial_payment">
            <div v-if="field_errors.hasOwnProperty('initial_payment')" class="help-block invalid-feedback d-block" v-html="field_errors['initial_payment'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'real_initial_payment' + _uid">Внёс</label>
            <input type="number" class="form-control" name="reward" :id="'real_initial_payment' + _uid" v-model="real_initial_payment">
            <div v-if="field_errors.hasOwnProperty('real_initial_payment')" class="help-block invalid-feedback d-block" v-html="field_errors['real_initial_payment'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'debt' + _uid">Долг</label>
            <input type="number" class="form-control" name="reward" :id="'debt' + _uid" v-model="debt">
            <div v-if="field_errors.hasOwnProperty('debt')" class="help-block invalid-feedback d-block" v-html="field_errors['debt'][0]"/>
        </div>
        <div class="form-group col-6">
            <label class="mb-0" :for="'deadline' + _uid">Оплатить до</label>
            <input type="date" class="form-control" name="deadline" :id="'deadline' + _uid" v-model="deadline">
            <div v-if="field_errors.hasOwnProperty('deadline')" class="help-block invalid-feedback d-block" v-html="field_errors['deadline'][0]"/>
        </div>
        <div class="form-group col-12 text-right">
            <button @click="generateForDeal" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
    </div>
</template>

<script>
import CounteragentSelect from "../../counteragents/CounteragentSelect";
import ProfileSelect from "../../requests/profiles/ProfileSelect";
import formMixin from "../formMixin";
import _ from "lodash";

export default {
    name: "SoglashenieNaDolg",
    mixins: [formMixin],
    components: {CounteragentSelect, ProfileSelect},
    props: {
        form_name: {
            type: String,
            required: true,
        },
        deal: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        isLoading: false,
        initial_payment: 0,
        real_initial_payment: 0,
        debt: 0,
        deadline: "",
        field_errors: {},
    }),
    mounted() {
        if (this.deal) {
            this.initial_payment = this.deal.sale_initial_payment / 100;
            if (this.initial_payment > 10000) this.real_initial_payment = this.initial_payment - 10000;
            this.debt = this.initial_payment - this.real_initial_payment;
        }
        this.deadline = moment().format('YYYY-MM-DD');
    },
    computed: {
        form_params() {
            return {
                form_name: this.form_name,
                initial_payment: this.initial_payment,
                real_initial_payment: this.real_initial_payment,
                debt: this.debt,
                deadline: this.deadline,
                deal_id: this.deal.id,
            };
        }
    }
}
</script>

<style scoped>

</style>
